module.exports = __webpack_public_path__ + "img/info.3709a3b3.svg";